import React, { useState } from 'react';
import './SolicitudReparacion.css'; // tus estilos

export default function SolicitudReparacion() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    dispositivo: '',
    descripcion: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cambia esta URL por la de tu función Firebase desplegada
  const FUNCTION_URL = "https://europe-west1-duxbyte.cloudfunctions.net/sendSolicitudEmail";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Error enviando el formulario');
      }

      setSubmitted(true);
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        dispositivo: '',
        descripcion: '',
      });
    } catch (err) {
      setError(err.message);
      console.error(err);
    }

    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="solicitud-container">
        <h2>¡Gracias por solicitar el diagnóstico!</h2>
        <p>Nos pondremos en contacto contigo pronto.</p>
        <button onClick={() => setSubmitted(false)} className="btn-reiniciar">
          Enviar otro formulario
        </button>
      </div>
    );
  }

  return (
    <div className="solicitud-container">
      <h2>Solicitud de Reparación</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit} className="solicitud-form">
        <input
          type="text"
          name="nombre"
          placeholder="Nombre completo"
          value={formData.nombre}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Correo electrónico"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="telefono"
          placeholder="Teléfono"
          value={formData.telefono}
          onChange={handleChange}
          required
        />
        <select
          name="dispositivo"
          value={formData.dispositivo}
          onChange={handleChange}
          required
        >
          <option value="">Selecciona un dispositivo</option>
          <option value="movil">Móvil</option>
          <option value="portatil">Portátil</option>
          <option value="tablet">Tablet</option>
          <option value="pc">PC de Escritorio</option>
          <option value="otro">Otro</option>
        </select>
        <textarea
          name="descripcion"
          placeholder="Describe el problema"
          rows="4"
          value={formData.descripcion}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={loading} className="btn-enviar">
          {loading ? 'Enviando...' : 'Solicitar Diagnóstico'}
        </button>
      </form>
    </div>
  );
}
